import http from 'conversations-http/clients/http';
export const restoreThread = ({
  threadId
}) => {
  const url = `conversations-threads/v1/threads/${threadId}/restore`;
  return http.post(url);
};